import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './Container.css';
export const Container = ({ label, children, withLeftPadding, }) => (_jsxs("div", Object.assign({ className: classNames(styles.container, { [styles.leftPadding]: withLeftPadding }) }, { children: [label && _jsx("p", Object.assign({ className: styles.label }, { children: label }), void 0), children] }), void 0));
